import React from 'react';
import { BlackFridayLanding } from './pages/BlackFridayLanding';
export function App() {
  return <BlackFridayLanding data-id="element-0" />;
}